<template>
  <div>
    <div class="productBanner"><Banner :classType="6" /></div>
    <Menu />

    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
      ref="one"
    >
      <h2>人才政策</h2>
      <p>talent policy</p>
    </div>

    <div class="wrap rcList productIbox">
      <el-row :gutter="32" class="wow animate__slideInUp">
        <el-col
          :xs="12"
          :sm="8"
          :md="6"
          :key="idx"
          v-for="(item, idx) in newsList"
        >
          <a :href="item.Url" target="_blank">
            <div class="item">
              <div class="item_pic">
                <div class="bimg">
                  <img :src="item.PicUrl" alt="" />
                </div>
              </div>
              <div class="item_tit ep2">{{ item.Title }}</div>
            </div>
          </a>
        </el-col>
      </el-row>
    </div>
    <div class="pageBox" >
      <Pagination @pageChange="getData" :PagingInfo="PagingInfo"  v-if="showPage"/>
    </div>
  </div>
</template>

<script>
import Menu from "./Menu.vue";
import Banner from "@/views/components/Banner";
import NewsList from "@/views/components/NewsList";
import Pagination from "@/views/components/Pagenation";
import { WOW } from "wowjs";

export default {
  data() {
    return {
      type: this.$route.query.type || "human",
      newsType: 7,
      newsList: [],
      PagingInfo: {},
      lang: "zh",
      Names: [],
      intro: {},
      pageCur: 1,
      showPage: false,
    };
  },
  methods: {
    getData(page, type) {
      this.$api
        .fileList({
          Type: this.newsType,
          CurrentPage: page,
          ItemsPerPage: 8,
        })
        .then((res) => {
          const { FileInfos, PagingInfo } = res.Value;
          this.newsList = FileInfos;
          console.log(res.Value,"+++")
          this.PagingInfo = PagingInfo;
          if (PagingInfo.TotalPages >1) {
            this.showPage = true
          }
          if (type) {
            this.$nextTick(() => {
              new WOW({
                boxClass: "wow",
                animateClass: "animate__animated",
                live: false,
              }).init();
            });
          }
        });
    },
  },

  beforeRouteEnter(to, from, next) {
    let fromURL = from.name;
    next((vm) => {
      if (fromURL == "resource")
        vm.pageCur = sessionStorage.getItem("currentPage");
    });
  },
  mounted() {
    this.type = this.$route.params.type;
    this.getData(1, "first");
  },
  components: {
    Menu,
    Banner,
    NewsList,
    Pagination,
  },
};
</script>

<style lang="scss">
.productIpd {
  padding-top: 50px;
  .el-table {
    margin-bottom: 50px;
    thead {
      color: #000;
    }
    th,
    td {
      text-align: center;
    }
  }
  .el-table th.el-table__cell {
    background-color: #f9f9f9;
  }
}
.productS {
  margin-top: 50px;
}
.productIbox {
  padding-top: 50px;
}
.proTit {
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  color: #000;
  padding: 50px 0 0 0;
}
.rcList {
  .item {
    height: 222px;
    padding: 30px;
    margin-bottom: 32px;
    border: 1px solid #bcbcbc;
    text-align: center;
    img {
      height: 110px;
    }
    .item_tit {
      margin-top: 20px;
    }
  }
}
@media (max-width: 768px) {
  .rcList .item {
    padding: 15px;
    margin: 10px -5px;
    height: auto;
  }
  .rcList .item .item_tit {
    margin-top: 5px;
  }
}
</style>
